var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaticBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1280,
    height: 717.022,
    viewBox: "0 0 1280 717.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffaaac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed2024"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M-533.031,75.961s63.507,136.116,267.448,107.421,279.744-21.4,362.757,64.589,229.3,71.686,381.9,44.706,240.1,45.434,267.834,95.3c.027-1.6-.049-717.012-.049-717.012l-1279.878.007Z",
    transform: "translate(533.031 329.032)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(0.089 0.042)",
    opacity: 0.759
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M-533.089,75.857S-466.142,235.8-265.644,203.5,29.04,209.88,92.742,280.116,327.447,343,480.03,315.029s242.088,27.86,266.881,72.952c.011.011-.249-717-.249-717l-1279.722-.018Z",
    transform: "translate(533 329)",
    opacity: 0.11,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M-533.031,75.961s63.507,136.116,267.448,107.421,279.744-21.4,362.757,64.589,229.3,71.686,381.9,44.706,240.1,45.434,267.834,95.3c.027-1.6-.049-717.012-.049-717.012l-1279.878.007Z",
    transform: "translate(532.981 328.997)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    "data-name": "Mask Group 6",
    transform: "translate(-0.05 -0.035)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-496.368,81.568s116.15-261.339,544.9-170.005S628.09-36.8,752.575-397.729",
    transform: "translate(513.475 376.877)",
    fill: "none",
    stroke: "#ff918b",
    strokeWidth: 128,
    opacity: 0.529
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticBackground);
export default __webpack_public_path__ + "static/media/static_background.76c74c173499cc68568240cb46becea9.svg";
export { ForwardRef as ReactComponent };